var _path, _rect, _path2, _path3, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPublicCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.30273,21.35449a17.34979,17.34979,0,0,0-3.87695-1.53711l-.38086,1.45117a15.8419,15.8419,0,0,1,3.541,1.40333Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.4043,
    y: 49.25,
    width: 4,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.27148,20.75244l.02344-1.5L40,19.25a17.476,17.476,0,0,0-3.85059.42822l.33008,1.46289A16.01225,16.01225,0,0,1,40,20.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.29883,34.6875a17.36751,17.36751,0,0,0-.96485-4.05908l-1.40625.52051a15.86719,15.86719,0,0,1,.88086,3.70752Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4043,
    y: 49.25,
    width: 4,
    height: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20,50.75h3.4043v-1.5H19.99805c-.15137,0-.36621-.00488-.54883-.01562l-.08984,1.49707q.3076.0183.61621.01855Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.07617,30.81348l.17774-1.48926a10.76909,10.76909,0,0,0-4.25684.35107l.418,1.44043A9.27691,9.27691,0,0,1,21.07617,30.81348Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.42969,26.91846a17.49481,17.49481,0,0,0-2.73047-3.14991l-1.00781,1.11036a16.01265,16.01265,0,0,1,2.49609,2.88037Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.22266,21.08447a17.435,17.435,0,0,0-3.47657,2.30323l.97266,1.14257a15.9021,15.9021,0,0,1,3.17578-2.105Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4043,50.75H48.75V50A6.75769,6.75769,0,0,0,42,43.25H38a6.75807,6.75807,0,0,0-6.70581,6H27.4043v1.5H32.75V50A5.25605,5.25605,0,0,1,38,44.75h4a5.24192,5.24192,0,0,1,5.17407,4.5H43.4043Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.27734,30.65771a15.87437,15.87437,0,0,1,1.85254-3.3291L25.915,26.44775a17.43574,17.43574,0,0,0-2.02637,3.64356Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.23145,49.63721l.666-1.34375A9.251,9.251,0,0,1,12.99414,46.04l-1.13476.98047A10.74,10.74,0,0,0,15.23145,49.63721Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.86133,49.72559,65.168,48.39551a7.50111,7.50111,0,0,1-3.501.85449H59.4043v1.5H61.667A9.10885,9.10885,0,0,0,65.86133,49.72559Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7041,32.80371l.332,1.46289a7.53512,7.53512,0,0,1,3.59961.07471l.38867-1.44824A9.03513,9.03513,0,0,0,59.7041,32.80371Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.19238,42.83838A9.26175,9.26175,0,0,1,10.75,39.99756q-.00147-.4109.03418-.8125L9.29,39.0542c-.02734.3125-.041.62842-.04.9458a10.75538,10.75538,0,0,0,.51465,3.29736Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.82812,35.66309a9.24068,9.24068,0,0,1,2.335-2.83887l-.94727-1.16309A10.7296,10.7296,0,0,0,10.50391,34.959Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.10645,46.87939A9.09334,9.09334,0,0,0,70.67188,42.856l-1.48633-.19532a7.59554,7.59554,0,0,1-1.30762,3.35743Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.793,36.07861a7.61969,7.61969,0,0,1,2.00293,2.99707l1.41015-.51269a9.12774,9.12774,0,0,0-2.39941-3.58985Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40,40.75A4.75,4.75,0,1,0,35.25,36,4.7554,4.7554,0,0,0,40,40.75Zm0-8A3.25,3.25,0,1,1,36.75,36,3.25377,3.25377,0,0,1,40,32.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublicCloud);
export default __webpack_public_path__ + "static/media/icon_public_cloud.31bf2a0f160b4b5ae85738a519d675a1.svg";
export { ForwardRef as ReactComponent };